/**
 * News and Events Hero Section
 */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import axios from 'axios';

const CMS_API_URL = process.env.REACT_APP_API_BASE_URL_CMS || '';

const NewsAndEventsHero = () => {
  const [heroData, setHeroData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHero = async () => {
      try {
        const response = await axios.post(
          `${CMS_API_URL}sections/get-by-uid`,
          { UID: 'NEWS-EVENTS-HERO' },
          {
            headers: { 'Content-Type': 'application/json' },
            timeout: 30000,
          }
        );

        if (response.data?.code === 1 && Array.isArray(response.data?.data) && response.data.data.length > 0) {
          const data = response.data.data[0];
          if (data.IsDeleted === false && data.IsPublished === true) {
            setHeroData(data);
          }
        }
      } catch (error) {
        console.error('Failed to fetch news events hero:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHero();
  }, []);

  const stripHtml = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim();
  };

  if (!loading && !heroData) {
    return null;
  }

  if (loading) {
    return (
      <section className="bg-[#2f3951] py-5 md:py-5">
        <div className="container mx-auto px-6 md:px-8 lg:px-12">
          <div className="h-4 w-48 bg-gray-600 rounded mb-3 animate-pulse" />
          <div className="h-8 w-64 bg-gray-600 rounded mb-2 animate-pulse" />
          <div className="w-24 h-1 bg-gray-600 mb-3 animate-pulse" />
          <div className="h-4 w-full max-w-2xl bg-gray-600 rounded animate-pulse" />
        </div>
      </section>
    );
  }

  return (
    <section className="bg-[#2f3951] py-5 md:py-5">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        {/* Breadcrumb */}
        <nav className="flex items-center text-white/80 text-sm mb-3">
          <Link to="/" className="flex items-center hover:text-[#ca9a37] transition-colors">
            <Home className="w-4 h-4 mr-1" />
            Home
          </Link>
          <ChevronRight className="w-4 h-4 mx-2" />
          <span className="text-[#ca9a37]">{heroData?.SubTitle || 'News and Events'}</span>
        </nav>

        {/* Title */}
        {heroData?.Title && (
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-2">
            {heroData.Title}
          </h1>
        )}
        <div className="w-24 h-1 bg-[#ca9a37] mb-3"></div>

        {heroData?.Description && (
          <p className="text-base text-gray-200 max-w-2xl line-clamp-3">
            {stripHtml(heroData.Description)}
          </p>
        )}
      </div>
    </section>
  );
};

export default NewsAndEventsHero;
